import { useCallback, useEffect, useState } from 'react'
import { Fade, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@material-ui/core'
import { useCardDashboardSincronizacaoStyles } from './card-dashboard-sincronizacao-styles'
import { useToastSaurus } from '../../../../service/app/use-cases'
import { useHistory } from 'react-router-dom'
import { formatDataHora } from '../../../../utils/format-data-hora'
import { CircularLoading } from '../../utils'
import { isEmpty, isNumber } from 'lodash'
import { CardNaoEncontrado } from '../card-nao-encontrado'
import { InformacaoIcon } from '../../icons'
import { useGetSincronizacaoDashboard } from '../../../../data/api/gestao/sincronizacao-dados/get-sincronizacao-dashboard'
import { SincronizacaoDadosModel } from '../../../../model/api/sincronizacao/sincronizacao-dados-model '
import { alterarNomeSituacao } from '../../../../utils/alterar-nome-situacao'
import { toDecimalString } from '../../../../utils/to-decimal'
import { alterarCorStatusSituacao } from '../../../../utils/alterar-cor-situacao'
import classNames from 'classnames'

export const CardDashboardSincronizacao = () => {
    const classes = useCardDashboardSincronizacaoStyles()
    const history = useHistory();
    const { showToast } = useToastSaurus()
    const { getSincronizacaoDashboard, carregando } = useGetSincronizacaoDashboard()

    const [queryStatus, setQueryStatus] = useState({
        page: 1,
        totalPages: 0,
        totalResults: 0,
        list: Array<SincronizacaoDadosModel>(),
    });

    const fillResult = useCallback(
        async (
            page: number,
            totalPages: number,
            totalResults: number,
            list: Array<SincronizacaoDadosModel>
        ) => {
            setQueryStatus({
                page: page,
                list: list,
                totalResults: totalResults,
                totalPages: totalPages,
            });
        },
        []
    );

    const search = useCallback(
        async (newPage: number) => {
            try {
                const resGet = await getSincronizacaoDashboard(newPage)
                if (resGet.erro) throw resGet.erro

                if (
                    resGet.resultado?.data?.pageIndex > resGet.resultado?.data?.totalPage &&
                    resGet.resultado?.data?.totalResult > 0
                ) {
                    search(resGet.resultado?.data?.totalPages);
                    return;
                }

                fillResult(
                    resGet.resultado?.data?.pageIndex,
                    resGet.resultado?.data?.totalPage,
                    resGet.resultado?.data?.totalResult,
                    resGet.resultado?.data?.results
                )
                return resGet;
            } catch (e: any) {
                showToast("error", e.message);
            }
        },
        [getSincronizacaoDashboard, fillResult, showToast]
    );

    useEffect(() => {
        search(queryStatus.page)
    }, [queryStatus.page, search]);

    const handleDashboard = () => {
        history.push('/sincronizacao');
    };

    return (
        <>
            {carregando ? (
                <CircularLoading tipo="FULLSIZED" />
            ) : null}
            <Fade in timeout={600}>
                <Tooltip 
                    placement='top' 
                    title="Clique para ir à tela de Sincronização"
                    classes={{ 
                        popper: classes.tooltipCustom 
                    }}
                >
                    <div className={classes.telaGrid} onClick={handleDashboard}>
                        {!isEmpty(queryStatus.list) ?
                            <>
                                <Typography className={classes.titleTelas}>Últimas Sincronizações</Typography>
                                <div className={classes.divider} />
                                <TableContainer component={Paper} className={classes.tableContainerFixedHeader}>
                                    <Table aria-label="sticky table" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align='center'>Aplicação</TableCell>
                                                <TableCell align='center'>Usuário</TableCell>
                                                <TableCell align='center'>Total de Produtos</TableCell>
                                                <TableCell align='center'>(%) Concluído</TableCell>
                                                <TableCell align='center'>Data Envio</TableCell>
                                                <TableCell align='center'>Data Conclusão</TableCell>
                                                <TableCell align='center'>Situação</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {queryStatus.list
                                                .sort((a, b) => new Date(b.ultimoEnvio).getTime() - new Date(a.ultimoEnvio).getTime())
                                                .filter((sincro, i) => i )
                                                .map((sincro, index) => (
                                                    <TableRow key={index} className={classNames(index % 2 === 0 && classes.cardCinza, classes.card)}>
                                                        <TableCell align='center'>{sincro?.aplicacao}</TableCell>
                                                        <TableCell align='center'>{sincro?.usuario}</TableCell>
                                                        <TableCell align='center'>{toDecimalString(sincro.totalProdutos, 0)} Itens</TableCell>
                                                        {isNumber(sincro?.porcentagem) ? (
                                                            <TableCell align='center'>{sincro?.porcentagem}%</TableCell>
                                                        ) : (
                                                            <TableCell align='center'>Sem porcentagem</TableCell>
                                                        )}
                                                        <TableCell align='center'>
                                                            <Typography>
                                                                {formatDataHora(new Date(sincro.dataCriacao))}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align='center'>{formatDataHora(new Date(sincro.ultimoEnvio))}</TableCell>
                                                        <TableCell align='center'>
                                                            {sincro.situacao ? (
                                                                <Typography className={classes.statusTable} style={{ background: alterarCorStatusSituacao(sincro.situacao) }}>
                                                                    {alterarNomeSituacao(sincro.situacao)}
                                                                </Typography>
                                                            ) : (
                                                                'Sem Situação'
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </>
                            :
                            <CardNaoEncontrado
                                mensagem="Nenhuma informação encontrada."
                                icon={<InformacaoIcon tipo="GERAL" />}
                            />
                        }
                    </div>
                </Tooltip>
            </Fade>
        </>
    )
}



